import React from "react";
import { StyledEngineProvider } from "@mui/material";

export default function InjectTailwind({ children }) {
  return <StyledEngineProvider injectFirst>{children}</StyledEngineProvider>;
}
